<script>
    export default {
        
    }
</script>

<template>
    <div class="card">
        <div class="card-image">
            <picture class="image is-16by9"><img width="320" height="180" alt="Placeholder image" /></picture>
        </div>
        <div class="card-content">
            <div class="block"><div class="progress is-large" value="0" max="100"></div></div>
            <div v-for="index in 2" :key="'skeleton-progress-' + index" class="block"><div class="progress" value="0" max="100"></div></div>
        </div>
    </div>
</template>
